export const serviceShortCodes = {
  "Dry Clean": "DC",
  Household: "HH",
  Laundry: "LD",
  Costumes: "CS",
  "Shoe & Luggage": "SL",
  "Wash & Fold": "WF",
};
